"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { useSimilarJobs } from "@repo/design-system/hooks/use-similar-jobs";
import type { SimilarJob } from "@repo/design-system/types/job";
import { getJobAdUrl } from "@repo/design-system/utils/helpers";
import { useInView } from "motion/react";
import { useRef } from "react";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function SimilarJobs(t0) {
  const $ = _c(32);
  const {
    job
  } = t0;
  const t = useLanguage();
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      margin: "600px 0px",
      once: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isAlmostInView = useInView(ref, t1);
  let t2;
  if ($[1] !== job.data.company || $[2] !== job.data.entryLevel) {
    t2 = {
      "data.company": job.data.company,
      "data.entryLevel": job.data.entryLevel
    };
    $[1] = job.data.company;
    $[2] = job.data.entryLevel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isAlmostInView || $[5] !== job.content.similarJobs || $[6] !== job.data.idClient || $[7] !== t2) {
    t3 = {
      idClient: job.data.idClient,
      filters: t2,
      initialSimilarJobs: job.content.similarJobs,
      enabled: isAlmostInView
    };
    $[4] = isAlmostInView;
    $[5] = job.content.similarJobs;
    $[6] = job.data.idClient;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: t4
  } = useSimilarJobs(t3);
  let t10;
  let t11;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[9] !== t || $[10] !== t4) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const similarJobs = t4 === undefined ? [] : t4;
      const displayJobs = similarJobs.slice(0, 3);
      if (!displayJobs.length) {
        let t12;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t12 = <div aria-hidden="true" ref={ref} />;
          $[18] = t12;
        } else {
          t12 = $[18];
        }
        t11 = t12;
        break bb0;
      }
      t9 = "outer-container bg-card py-container";
      t10 = "similarJobs";
      t7 = "inner-container grid gap-y-4";
      if ($[19] !== t.jobad_similarJobs_HL) {
        t8 = <h2 className="mb-3 font-bold text-3xl text-foreground" data-source="lc">{t.jobad_similarJobs_HL}</h2>;
        $[19] = t.jobad_similarJobs_HL;
        $[20] = t8;
      } else {
        t8 = $[20];
      }
      t5 = "grid list-none grid-flow-row auto-rows-fr grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:gap-8";
      t6 = displayJobs.map(_temp);
    }
    $[9] = t;
    $[10] = t4;
    $[11] = t10;
    $[12] = t11;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  let t12;
  if ($[21] !== t5 || $[22] !== t6) {
    t12 = <ul className={t5}>{t6}</ul>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t7 || $[26] !== t8) {
    t13 = <div className={t7}>{t8}{t12}</div>;
    $[24] = t12;
    $[25] = t7;
    $[26] = t8;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t13 || $[30] !== t9) {
    t14 = <section className={t9} id={t10}>{t13}</section>;
    $[28] = t10;
    $[29] = t13;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}
function _temp(similarJob) {
  return <SimilarJobCard job={similarJob} key={similarJob.idClient} />;
}
export function SimilarJobCard(t0) {
  const $ = _c(12);
  const {
    job
  } = t0;
  let t1;
  if ($[0] !== job.city || $[1] !== job.idClient || $[2] !== job.title) {
    t1 = getJobAdUrl(job.title, job.city, job.idClient);
    $[0] = job.city;
    $[1] = job.idClient;
    $[2] = job.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const href = t1;
  let t2;
  if ($[4] !== job.title) {
    t2 = <p className="w-full hyphens-auto break-words font-bold leading-tight underline decoration-inherit [word-break:break-word]" data-source="job">{job.title}</p>;
    $[4] = job.title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== job.company) {
    t3 = <p className="break-words text-lg" data-source="job">{job.company}</p>;
    $[6] = job.company;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== href || $[9] !== t2 || $[10] !== t3) {
    t4 = <li className="list-none"><CustomLink blank={true} className="flex h-full w-full flex-col justify-between gap-12 bg-primary p-8 text-2xl text-white decoration-transparent transition-all duration-200 hover:decoration-white hover:brightness-90" href={href}>{t2}{t3}</CustomLink></li>;
    $[8] = href;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}